import ConfirmModal from '../confirm_modal/confirm_modal.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  publicTimelineVisible,
  federatedTimelineVisible,
  bubbleTimelineVisible,
} from '../../lib/timeline_visibility'
import {
  faSignInAlt,
  faSignOutAlt,
  faHome,
  faComments,
  faUserPlus,
  faBullhorn,
  faSearch,
  faTachometerAlt,
  faCog,
  faPaintBrush,
  faGlobe,
  faBolt,
  faUsers,
  faCommentMedical,
  faBookmark,
  faInfoCircle,
  faUserTie
} from '@fortawesome/free-solid-svg-icons'
import { mapState } from 'vuex'

library.add(
  faSignInAlt,
  faSignOutAlt,
  faHome,
  faComments,
  faUserPlus,
  faBullhorn,
  faSearch,
  faTachometerAlt,
  faCog,
  faPaintBrush,
  faGlobe,
  faBolt,
  faUsers,
  faCommentMedical,
  faBookmark,
  faInfoCircle,
  faUserTie
)

export default {
  components: {
    ConfirmModal
  },
  data: () => ({
    supportsMask: window.CSS && window.CSS.supports && (
      window.CSS.supports('mask-size', 'contain') ||
        window.CSS.supports('-webkit-mask-size', 'contain') ||
        window.CSS.supports('-moz-mask-size', 'contain') ||
        window.CSS.supports('-ms-mask-size', 'contain') ||
        window.CSS.supports('-o-mask-size', 'contain')
    ),
    showingConfirmLogout: false
  }),
  computed: {
    enableMask () { return this.supportsMask && this.$store.state.instance.logoMask },
    logo () { return this.$store.state.instance.logo },
    mergedConfig () {
      return this.$store.getters.mergedConfig
    },
    sitename () { return this.$store.state.instance.name },
    hideSiteFavicon () {
      return this.mergedConfig.hideSiteFavicon
    },
    hideSiteName () {
      return this.mergedConfig.hideSiteName
    },
    hideSitename () { return this.$store.state.instance.hideSitename },
    logoLeft () { return this.$store.state.instance.logoLeft },
    currentUser () { return this.$store.state.users.currentUser },
    privateMode () { return this.$store.state.instance.private },
    shouldConfirmLogout () {
      return this.$store.getters.mergedConfig.modalOnLogout
    },
    showBubbleTimeline () {
      return this.$store.state.instance.localBubbleInstances.length > 0
    },
    ...mapState({
      publicTimelineVisible,
      federatedTimelineVisible,
      bubbleTimelineVisible,
    })
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    openSearchModal ()  {
      this.$store.dispatch('openSearchModal')
    },
    openSettingsModal () {
      this.$store.dispatch('openSettingsModal')
    },
    openThemeTab () {
      this.$store.dispatch('openSettingsModalTab', 'theme')
    },
    openModModal () {
      this.$store.dispatch('openModModal')
    }
  }
}
